import { format, isValid, parseISO } from 'date-fns';

// Chrome の日付入力は年を6桁まで受け付けるため、max で4桁に制限する
export const MAX_DATE_INPUT = '9999-12-31';

export const isValidYMD = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value) && isValid(parseISO(value));

export const formatYMD = (value?: string | null, emptyValue = '-', formatStr = 'yyyy-MM-dd') => {
  if (!value) {
    return emptyValue;
  }
  const date = parseISO(value);
  return isValid(date) ? format(date, formatStr) : emptyValue;
};

export const formatYMDhm = (value?: string | null, emptyValue = '-') =>
  formatYMD(value, emptyValue, 'yyyy/M/d HH:mm');

export const formatYMDSlash = (value?: string | null, emptyValue = '-') =>
  formatYMD(value, emptyValue, 'yyyy/M/d');
